import React from 'react';

interface USDCIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

export const USDCIcon: React.FC<USDCIconProps> = ({
  width = 18,
  height = 18,
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="9" cy="9" r="9" fill="#2775CA" />
      <path
        d="M9.92917 11.8334C9.92917 10.8834 9.27917 10.5167 7.97917 10.2667C6.67917 10.0167 6.02917 9.58337 6.02917 8.71671C6.02917 7.85004 6.67917 7.25004 7.82917 7.25004C8.82917 7.25004 9.47917 7.68337 9.72917 8.46671C9.80417 8.71671 10.0542 8.88337 10.3042 8.88337H10.4708C10.8875 8.88337 11.1375 8.46671 10.9708 8.13337C10.5542 7.18337 9.65417 6.56671 8.58333 6.48337V5.58337C8.58333 5.25004 8.33333 5 8 5C7.66667 5 7.41667 5.25004 7.41667 5.58337V6.48337C5.93333 6.65004 4.95833 7.68337 4.95833 8.80004C4.95833 9.75004 5.60833 10.2667 6.90833 10.5167C8.20833 10.7667 8.85833 11.0334 8.85833 12.0667C8.85833 12.9334 8.125 13.6167 7.05417 13.6167C5.90417 13.6167 5.25417 13.0167 5.08333 12.2334C5.00833 11.9834 4.75833 11.8167 4.50833 11.8167H4.34167C3.925 11.8167 3.675 12.2334 3.84167 12.5667C4.25833 13.6834 5.25417 14.3 6.40417 14.4834V15.4167C6.40417 15.75 6.65417 16 6.98751 16C7.32084 16 7.57084 15.75 7.57084 15.4167V14.4834C9.05417 14.2334 9.92917 13.2 9.92917 11.8334Z"
        fill="white"
      />
      <path
        d="M13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9ZM14 9C14 11.7614 11.7614 14 9 14C6.23858 14 4 11.7614 4 9C4 6.23858 6.23858 4 9 4C11.7614 4 14 6.23858 14 9Z"
        fill="white"
      />
    </svg>
  );
};

export default USDCIcon;
